import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";
import SinConexionKawaii from "../SinConexionKawaii";
import ImagenNoDisponibleKawaii from "../ImagenNoDisponibleKawaii";

// Template60: Página de Torre de Tokio
// Copia DIRECTA del componente PageTowerTokyo.jsx de guia-tokio, adaptado para usar las props del sistema guia
const Template60 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
	updatePage,
	onMapFullscreenChange,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;
	const [loaded, setLoaded] = useState(navigator.onLine);
	const [fullscreen, setFullscreen] = useState(false);
	const [isOnline, setIsOnline] = useState(navigator.onLine);
	const [torreStickerError, setTorreStickerError] = useState(false);
	const [temploImageError, setTemploImageError] = useState(false);
	const [torreImageError, setTorreImageError] = useState(false);

	const headerText = page.texts?.[0]?.content;
	const logoImage = page.canvasImages?.find(
		(img) => img.id === "logo",
	)?.imageUrl;

	// Lógica especial para la guía de Tokio: header #24221a en primera página, #e24217 en las siguientes
	const pageOrder =
		page.order !== undefined
			? page.order
			: page.data?.order !== undefined
				? page.data.order
				: -1;
	const isTokioGuide = headerBackgroundColor === "#24221a";
	const actualHeaderColor =
		isTokioGuide && pageOrder > 0 ? "#e24217" : headerBackgroundColor;

	const getImageSrc = (id) => {
		if (page.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found && found.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found && found.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const torreTokioImage = getImageSrc("torre-main");
	const torreImage = getImageSrc("torre-2");
	const temploImage = getImageSrc("torre-templo");
	const torreSticker = getCanvasImageUrl("torre-sticker");

	const mapUrl = page.maps?.[0];
	const stickerZojoText = page.texts?.[8]?.content;
	const comoLlegarTitle = page.texts?.[9]?.content;
	const comoLlegarHtml = page.texts?.[10]?.content;
	const zojoTitle = page.texts?.[11]?.content;
	const zojoText = page.texts?.[12]?.content;
	const sabiasQueZojoHtml = page.texts?.[13]?.content;
	const torreTitle = page.texts?.[14]?.content;
	const torreTextHtml = page.texts?.[15]?.content;
	const sabiasQueTorreHtml = page.texts?.[16]?.content;

	const parseSabiasQueItem = (html) => {
		if (!html) return null;
		const parser = new DOMParser();
		const doc = parser.parseFromString(html, "text/html");
		const p = doc.querySelector("p");
		if (!p) return null;
		const text = (p.textContent ?? p.innerText ?? "").trim();
		const emojiMatch = text.match(/^([^\s]+)\s+(.*)/s);
		if (emojiMatch)
			return { icono: emojiMatch[1], texto: emojiMatch[2].trim() };
		return null;
	};
	const sabiasQueZojo = parseSabiasQueItem(sabiasQueZojoHtml);
	const sabiasQueTorre = parseSabiasQueItem(sabiasQueTorreHtml);

	useEffect(() => {
		const handleOnline = () => {
			setIsOnline(true);
			setLoaded(true);
		};
		const handleOffline = () => {
			setIsOnline(false);
			setLoaded(true);
		};

		window.addEventListener("online", handleOnline);
		window.addEventListener("offline", handleOffline);

		return () => {
			window.removeEventListener("online", handleOnline);
			window.removeEventListener("offline", handleOffline);
		};
	}, []);

	useEffect(() => {
		const style = document.createElement("style");
		style.innerHTML = `
			@keyframes spin {
				0% { transform: rotate(0deg); }
				100% { transform: rotate(360deg); }
			}
		`;
		document.head.appendChild(style);
		return () => document.head.removeChild(style);
	}, []);

	// Estilos reutilizables
	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "14px",
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};

	const contentColor = textColor || "#444";

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "13px",
		color: contentColor,
		margin: 0,
	};

	if (fullscreen) {
		return (
			<Box
				sx={{
					position: "fixed",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					backgroundColor: "#fff",
					zIndex: 9999,
					display: "flex",
					flexDirection: "column",
				}}
			>
				<Box
					sx={{
						padding: "10px",
						textAlign: "right",
						backgroundColor: "#24221a",
					}}
				>
					<Box
						component="button"
						onClick={() => {
							setFullscreen(false);
							onMapFullscreenChange?.(false);
						}}
						sx={{
							backgroundColor: "#fff",
							color: "#24221a",
							border: "none",
							borderRadius: "8px",
							padding: "6px 12px",
							fontWeight: 600,
							cursor: "pointer",
							fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
						}}
					>
						← Volver a la guía
					</Box>
				</Box>
				{isOnline && mapUrl ? (
					<Box
						component="iframe"
						title="Mapa grande"
						src={mapUrl}
						width="100%"
						height="100%"
						sx={{
							border: 0,
							flex: 1,
						}}
						allowFullScreen
						loading="lazy"
					/>
				) : (
					<Box
						sx={{
							flex: 1,
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
						}}
					>
						<SinConexionKawaii
							height="100%"
							fontFamily={fontFamily || "'Poppins', sans-serif"}
						/>
					</Box>
				)}
			</Box>
		);
	}

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				width: "100%",
				backgroundColor: backgroundColor || "#d2ebf0",
				color: contentColor,
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *:not([data-template-header])": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
					color: "inherit",
				},
				"& p": {
					marginTop: "0px !important",
					marginBottom: "10px !important",
				},
			}}
		>
			{headerText && (
				<Box
					data-block-id="header"
					data-template-header
					sx={{
						backgroundColor: actualHeaderColor,
						color: headerTextColor || "#fff",
						textAlign: "center",
						padding: "15px 0",
						fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
						fontSize: "14px",
						fontWeight: 800,
						flexShrink: 0,
						position: "sticky",
						top: 0,
						zIndex: 9999,
					}}
				>
					{headerText}
				</Box>
			)}

			{/* MAPA */}
			{(mapUrl || torreTokioImage) && (
				<Box
					data-block-id="map"
					sx={{
						position: "relative",
						backgroundColor: backgroundColor || "#d2ebf0",
						marginTop: "-70px",
						height: isSmallScreen ? 320 : 400,
						minHeight: isSmallScreen ? 320 : 400,
					}}
				>
					<Box
						sx={{
							position: "absolute",
							top: 0,
							left: 0,
							right: 0,
							bottom: 0,
							width: "100%",
							height: "100%",
						}}
					>
						{!loaded && isOnline && (
							<Box
								sx={{
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									height: "100%",
									color: "black",
									fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
									fontSize: 14,
									position: "absolute",
									top: 0,
									left: 0,
									right: 0,
									bottom: 0,
									zIndex: 1,
								}}
							>
								<Box
									sx={{
										width: 20,
										height: 20,
										border: "4px solid #ccc",
										borderTop: "4px solid #24221a",
										borderRadius: "50%",
										animation: "spin 1s linear infinite",
									}}
								/>
							</Box>
						)}

						{isOnline && mapUrl && (
							<Box
								component="button"
								onClick={() => {
									setFullscreen(true);
									onMapFullscreenChange?.(true);
								}}
								sx={{
									position: "absolute",
									top: "80px",
									right: "10px",
									backgroundColor: "#24221a",
									color: "#fff!important",
									padding: "8px 10px",
									fontSize: "11px",
									borderRadius: "8px",
									textDecoration: "none",
									fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
									boxShadow: "1px 1px 2px rgba(0,0,0,0.2)",

									border: "none",
									cursor: "pointer",
								}}
							>
								Ver mapa grande
							</Box>
						)}

						{isOnline && mapUrl ? (
							<Box
								component="iframe"
								title="Mapa"
								src={mapUrl}
								allowFullScreen=""
								loading="lazy"
								sx={{
									border: 0,
									position: "absolute",
									top: 0,
									left: 0,
									width: "100%",
									height: "100%",
									display: "block",
								}}
								onLoad={() => setLoaded(true)}
							/>
						) : !isOnline ? (
							<SinConexionKawaii
								height="100%"
								fontFamily={fontFamily || "'Poppins', sans-serif"}
							/>
						) : null}
					</Box>
					{torreSticker && !torreStickerError && (
						<img
							src={torreSticker}
							alt=""
							onError={() => setTorreStickerError(true)}
							style={{
								width: 120,
								position: "absolute",
								bottom: -20,
								right: -20,
							}}
						/>
					)}
					{stickerZojoText && (
						<Box
							sx={{
								position: "absolute",
								bottom: isSmallScreen ? "80px" : "60px",
								right: isSmallScreen ? "6px" : "40px",
								backgroundColor: "#fff8db",
								border: "2px solid #f5c400",
								borderRadius: "16px 16px 0px 16px",
								padding: "10px 12px",
								fontSize: 11,
								fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
								color: contentColor,
								boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
								maxWidth: 120,
							}}
						>
							{stickerZojoText}
						</Box>
					)}
				</Box>
			)}

			{/* CONTENIDO */}
			<Box sx={{ padding: "10px 12px", position: "relative" }}>
				{(comoLlegarTitle || comoLlegarHtml) && (
					<Box
						data-block-id="text-1"
						sx={{
							backgroundColor: "#ffe3cc",
							border: "3px solid #f28b35",
							borderRadius: "12px",
							padding: "12px 12px",
							fontSize: 12,
							fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
							color: "#333",
							position: "relative",
							width: "100%",
							paddingBottom: "0px",
							marginBottom: "14px",
						}}
					>
						{comoLlegarTitle && (
							<Box
								component="h4"
								sx={{
									margin: 0,
									marginBottom: "8px",
									fontSize: 13,
									fontWeight: 700,
									color: "#f28b35!important",
									textTransform: "uppercase",
									fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
								}}
							>
								{comoLlegarTitle}
							</Box>
						)}
						{comoLlegarHtml && (
							<Box
								component="p"
								sx={estiloP}
								dangerouslySetInnerHTML={{ __html: comoLlegarHtml }}
							/>
						)}
					</Box>
				)}

				{(zojoTitle || zojoText || temploImage) && (
					<Box
						data-block-id="text-2"
						sx={{
							flex: 1,
							display: "flex",
							flexDirection: "column",
							gap: "16px",
							position: "relative",
						}}
					>
						<Box
							sx={{
								display: "flex",
								gap: "20px",
								alignItems: "flex-start",
							}}
						>
							{temploImage &&
								(!temploImageError ? (
									<img
										src={temploImage}
										alt="Templo"
										onError={() => setTemploImageError(true)}
										style={{
											width: "40%",
											height: 110,
											borderRadius: "12px",
											objectFit: "cover",
										}}
									/>
								) : (
									<ImagenNoDisponibleKawaii
										width="40%"
										height={110}
										fontFamily={fontFamily || "'Poppins', sans-serif"}
										compact
									/>
								))}
							{sabiasQueZojo && (
								<Box sx={{ position: "absolute", top: 0, left: "35%" }}>
									<SabiasQue
										icono={sabiasQueZojo.icono}
										texto={sabiasQueZojo.texto}
									/>
								</Box>
							)}
							<Box sx={{ width: temploImage ? "60%" : "100%" }}>
								{zojoTitle && (
									<Box component="h3" sx={estiloH3}>
										{zojoTitle}
									</Box>
								)}
								{zojoText && (
									<Box component="p" sx={estiloP}>
										{zojoText}
									</Box>
								)}
							</Box>
						</Box>
					</Box>
				)}

				{(torreTitle || torreTextHtml || torreImage) && (
					<Box
						data-block-id="text-3"
						sx={{
							flex: 1,
							display: "flex",
							flexDirection: "column",
							gap: "16px",
							position: "relative",
							marginTop: "16px",
						}}
					>
						<Box
							sx={{
								display: "flex",
								gap: "20px",
								alignItems: "flex-start",
							}}
						>
							{torreImage &&
								(!torreImageError ? (
									<img
										src={torreImage}
										alt="Torre"
										onError={() => setTorreImageError(true)}
										style={{
											width: "40%",
											height: 110,
											borderRadius: "12px",
											objectFit: "cover",
										}}
									/>
								) : (
									<ImagenNoDisponibleKawaii
										width="40%"
										height={110}
										fontFamily={fontFamily || "'Poppins', sans-serif"}
										compact
									/>
								))}
							<Box sx={{ width: torreImage ? "60%" : "100%" }}>
								{torreTitle && (
									<Box component="h3" sx={estiloH3}>
										{torreTitle}
									</Box>
								)}
								{torreTextHtml && (
									<Box
										component="p"
										sx={{
											...estiloP,
											"& a": {
												color: "#f28b35",
												fontWeight: 600,
												textDecoration: "underline",
											},
										}}
										dangerouslySetInnerHTML={{ __html: torreTextHtml }}
									/>
								)}
							</Box>
							{sabiasQueTorre && (
								<Box sx={{ position: "absolute", top: 0, left: "35%" }}>
									<SabiasQue
										icono={sabiasQueTorre.icono}
										texto={sabiasQueTorre.texto}
									/>
								</Box>
							)}
						</Box>
					</Box>
				)}
			</Box>
		</Box>
	);
};

Template60.thumbnail = "/images/template-1.png";

export default Template60;
